import {Layout} from "@components";
import React, {useEffect, useMemo, useState} from "react";
import styles from "./style.module.scss";
import {ScreenId, Svgs} from "@assets";
import * as Datas from "@data";
import {useNav} from "@hook";
import {api} from "@utils";
import {InputBox, Pagination} from "@adminComponents";
import moment from "moment";
import {useRecoilValue} from "recoil";
import {states} from "@recoils";

export default function HomePage() {
  const {navigate} = useNav();
  const advData = useRecoilValue(states.advDataState);
  const [listData, setListData] =
    useState<Datas.ResultPagingResponse<Datas.INoticeListResponse[]>>();
  const [searchData, setSearchData] = useState<{
    searchTxt?: string;
  }>({});

  const jAdv = useMemo(() => {
    const jAdv = advData.find(
      item => (item.type || "").toLocaleUpperCase() === "J",
    );
    return jAdv;
  }, [advData]);

  async function getList({page = 1}: {page?: number} = {}) {
    try {
      const {success, data} = await api.v1.notice.getList({
        page,
        limit: 15,
        ...searchData,
      });
      if (success) {
        setListData(data);
      }
    } catch (error) {
      console.error("getList error", error);
    }
  }

  function goToDetail({data}: {data: Datas.INotice}) {
    if (!data || !data.no) {
      return;
    }
    navigate({
      url: ScreenId.NOTICE_DETAIL,
      state: {data},
      params: {no: data.no},
      scrollToTop: false,
    });
  }

  useEffect(() => {
    getList();
  }, []);

  return (
    <Layout>
      <div className={styles.container}>
        {!!jAdv && (
          <div className={styles.advContainer}>
            <img src={jAdv.files?.[0]?.url} alt={jAdv.title || "광고"} />
          </div>
        )}

        <div className={styles.listContainer}>
          <div className={styles.searchContainer}>
            <div className={styles.count}>
              총 {(listData?.page?.maxcnt || 0).toLocaleString()}개
            </div>
            <div className={styles.textContainer}>
              <InputBox
                value={searchData.searchTxt}
                onValue={value =>
                  setSearchData({...searchData, searchTxt: value})
                }
                boxClassName={styles.inputBox}
                focusBoxClassName={styles.inputBoxFocus}
                onEnter={getList}
                rightContent={<Svgs.Search />}
                placeholder="검색어를 입력해주세요"
              />
            </div>
          </div>
          <div className={styles.pcListContainer}>
            <table>
              <colgroup>
                <col width={80} />
                <col />
                <col width={120} />
              </colgroup>
              <thead>
                <tr>
                  <td>번호</td>
                  <td>제목</td>
                  <td>등록일</td>
                </tr>
              </thead>
              <tbody>
                {(listData?.result || []).length === 0 ? (
                  <tr className={styles.emptyRow}>
                    <td colSpan={3}>검색결과가 없습니다.</td>
                  </tr>
                ) : (
                  <>
                    {listData?.result.map(item => (
                      <tr
                        key={item.no}
                        onClick={() => goToDetail({data: item})}>
                        <td>
                          <div className={styles.badge}>공지</div>
                        </td>
                        <td className={styles.title}>{item.title}</td>
                        <td>{moment(item.created_at).format("YYYY-MM-DD")}</td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          <div className={styles.mobileListContainer}>
            {(listData?.result || []).length === 0 ? (
              <div className={[styles.item, styles.emptyRow].join(" ")}>
                검색결과가 없습니다.
              </div>
            ) : (
              <>
                {listData?.result.map(item => (
                  <div
                    key={item.no}
                    className={styles.item}
                    onClick={() => goToDetail({data: item})}>
                    <div className={styles.badge}>공지</div>
                    <div className={styles.textContainer}>
                      <div className={styles.topRow}>{item.title}</div>
                      <div className={styles.bottomRow}>
                        <div>
                          {moment(item.created_at).format("YYYY-MM-DD")}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div className={styles.pageContainer}>
            <Pagination paging={listData?.page} getList={getList} />
          </div>
        </div>
      </div>
    </Layout>
  );
}
